import { useContext, useEffect, useState } from 'react';
import Inputs from './components/Inputs';
import { urls } from './api/urls';
import useHttp from '../../../hooks/use-http';
import GridProvider from './components/GridProvider';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import MuiDialog from '../../UI/MuiDialog/MuiDialog';
import { handleErrorMessage } from '../../../../shared/api/handleErrorMessage';
import { isFormValid } from './validation/isFormValid';
import { TabContext } from '../../../Context/TabContext';

const INITIAL_VALUES = {
  id: 0,
  naziv: '',
  redosled: '',
};
const StavkeRN = ({ save, handleSave, novi, handleNovi }) => {
  const { sendRequest, getData, data, isLoading } = useHttp('');
  const [formValues, setFormValues] = useState(INITIAL_VALUES);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openPopUp, setOpenPopUp] = useState(false);
  const { t, i18n } = useTranslation();
  const { tabsData, activeComponent, onTabChange } = useContext(TabContext);
  const dataLocal = tabsData.find((item) => item.type === activeComponent);
  const localFormData = dataLocal?.formValues ? dataLocal?.formValues : {};

  useEffect(() => {
    const tab = {
      type: 1080,
      title: 'Stavke RN',
      icon: 'fas fa-list',
      formValues: formValues,
    };
    onTabChange(tab);
  }, [formValues]);
  useEffect(() => {
    if (Object.keys(localFormData).length > 0) {
      setFormValues({
        ...localFormData,
      });
    }
  }, []);

  const vratiPodatke = () => {
    sendRequest({ url: urls.VARATI_STAVKE });
  };

  useEffect(() => {
    vratiPodatke();
  }, []);

  const handleSaveData = async () => {
    if (isFormValid(formValues)) {
      return;
    }
    const config = {
      method: 'POST',
      url: formValues.id !== 0 ? urls.UPDATE_STAVKE : urls.INSERT_STAVKE,
      data: {
        id: formValues.id,
        proveravanaStavka: formValues.naziv,
        redosled: +formValues.redosled,
        idKorProm: +localStorage.idKorisnika,
      },
    };
    const result = await getData(config);
    if (result.id > 0) {
      vratiPodatke();
      setFormValues(INITIAL_VALUES);
      toast.success(
        formValues.id === 0
          ? 'Uspešan unos podataka'
          : 'Uspešna izmena podataka',
      );
      return;
    }
    toast.error(handleErrorMessage(result));
  };

  useEffect(() => {
    if (novi) {
      handleNovi(false);
      setFormValues(INITIAL_VALUES);
    }
  }, [novi]);

  useEffect(() => {
    if (save) {
      handleSaveData();
      handleSave(false);
    }
  }, [save]);

  const handleOpenDeleteDialog = (id) => {
    setOpenDeleteDialog(true);
    setFormValues({ ...INITIAL_VALUES, id: id });
  };
  const handleEditData = async (item) => {
    setFormValues((curr) => {
      return { ...curr, ...item, naziv: item.proveravanaStavka };
    });
    setOpenPopUp(true);
  };
  const handleDelete = async () => {
    const config = {
      method: 'POST',
      url: urls.DELETE_STAVKE,
      data: {
        id: formValues.id,
      },
    };
    const result = await getData(config);
    if (result > 0) {
      vratiPodatke();
      setFormValues(INITIAL_VALUES);
      setOpenDeleteDialog(false);
      return;
    }
    toast.error(handleErrorMessage(result));
  };
  return (
    <div>
      <Inputs formValues={formValues} setFormValues={setFormValues} />
      <GridProvider
        data={data}
        handleOpenDeleteDialog={handleOpenDeleteDialog}
        handleEditData={handleEditData}
        loading={isLoading}
      />
      <MuiDialog
        maxWidth="sm"
        open={openDeleteDialog}
        title={t('warning')}
        text={t('warningDelete')}
        handleClose={() => {
          setOpenDeleteDialog(false);
          setFormValues(INITIAL_VALUES);
        }}
        handleConfirm={handleDelete}
        deniedText="ZATVORI"
      />
    </div>
  );
};

export default StavkeRN;
